import { makeStyles } from "@tiny/components";

export const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    marginBottom: 12,
    [theme.breakpoints.up("md")]: {
      marginBottom: 16,
    },
  },
  wrap: {
    display: "flex",
    flexDirection: "column",
    padding: "12px 16px 0 16px",
    [theme.breakpoints.up("md")]: {
      flexDirection: "row",
      padding: "16px 24px 0 24px",
    },
  },
  top: {
    display: "flex",
    minHeight: 40,
    marginBottom: 12,
    [theme.breakpoints.up("md")]: {
      flex: 1,
      marginBottom: 0,
    },
  },
  check: {
    flex: "0 0 32px",
    display: "flex",
    alignItems: "center",
  },
  search: {
    display: "flex",
    flex: 1,
  },
  searchField: {
    [theme.breakpoints.up("md")]: {
      width: 270,
    },
  },
  button: {
    minWidth: 36,
    marginLeft: 12,
    paddingLeft: 0,
    paddingRight: 0,
    fontSize: 0,
    "& .MuiButton-endIcon": {
      marginLeft: 0,
    },
    [theme.breakpoints.up("md")]: {
      marginLeft: 8,
      fontSize: 12,
      paddingLeft: 12,
      paddingRight: 12,
      "& .MuiButton-endIcon": {
        marginLeft: 4,
      },
    },
  },
  selected: {
    flex: 1,
    display: "flex",
    alignItems: "center",
  },
  moveButton: {
    marginRight: 8,
  },
  deleteButton: {
    marginRight: 8,
  },
  bottom: {
    display: "flex",
    [theme.breakpoints.up("md")]: {
      flex: 1,
      justifyContent: "flex-end",
    },
  },
  actions: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.up("md")]: {
      flex: 0,
    },
  },
  sort: {
    flex: 1,
    [theme.breakpoints.up("md")]: {
      marginLeft: 20,
      flex: "0 0  204px",
    },
  },
  tags: {
    display: "flex",
    flexWrap: "wrap",
    marginTop: 6,
    padding: "0 16px",
    "& > div": {
      marginTop: 6,
      maxWidth: "-webkit-fill-available",
    },
  },
}));
